import { Component, Input } from '@angular/core';

@Component({
  selector: 'ling-page-block',
  templateUrl: './page-block.component.html',
  styleUrls: ['./page-block.component.scss'],
})
export class PageBlockComponent {
  @Input() title = '';
}
